import { GridCellKind, getMiddleCenterBias } from '@glideapps/glide-data-grid';

import type { CustomRenderer } from '@glideapps/glide-data-grid';

import { formatterCurrency } from '@/utilities/format';

import { isCustomCellOfKind } from '../utils';

import type { TotalCostCell } from './types';

import { kind } from './types';

export const Render: CustomRenderer<TotalCostCell> = {
  kind: GridCellKind.Custom,
  isMatch: isCustomCellOfKind(kind),
  draw: (args, cell) => {
    const { ctx, theme, rect } = args;
    const { value, currencyISO } = cell.data;

    const text =
      value && currencyISO
        ? formatterCurrency(Number(value), currencyISO)
        : String(value ?? '');

    ctx.beginPath();
    ctx.fillStyle = 'rgba(0, 0, 0, 0.02)';
    ctx.rect(rect.x + 1, rect.y + 1, rect.width, rect.height - 2);
    ctx.fill();

    ctx.fillStyle = theme.textDark;

    ctx.fillText(
      text,
      rect.x + theme.cellHorizontalPadding,
      rect.y + rect.height / 2 + getMiddleCenterBias(ctx, theme)
    );

    return true;
  },
  measure: (ctx, cell, theme) => {
    const { value } = cell.data;
    return (
      (value ? ctx.measureText(String(value ?? '')).width : 0) +
      theme.cellHorizontalPadding * 2
    );
  },
  provideEditor: () => ({
    editor: () => null,
    disablePadding: true,
  }),
};
